import {
  Component,
  HostBinding,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
} from "@angular/core";
import { Store } from "@ngrx/store";
import { Subject, takeUntil } from "rxjs";
import { AppStateInterface } from "src/app/store/appState.interface";
import { MenuAction } from "../../../models/side-bar-menu.interface";

/**
 * Sidebar entry that dispatches a store action instead of navigating.
 * Applied on the `<a>` itself so the theme's sidebar link styles still match.
 */
@Component({
  selector: "a[appSidebarAction]",
  templateUrl: "./sidebar-action.component.html",
  styleUrls: ["./sidebar-action.component.scss"],
})
export class SidebarActionComponent implements OnInit, OnDestroy {
  @Input("appSidebarAction") menuAction?: MenuAction;

  @HostBinding("attr.role") readonly role = "button";
  @HostBinding("attr.aria-busy") pending = false;

  private ngDestroyed$ = new Subject<void>();

  constructor(private store: Store<AppStateInterface>) {}

  @HostBinding("attr.aria-disabled")
  get disabled(): boolean {
    return this.pending;
  }

  ngOnInit(): void {
    if (!this.menuAction) {
      return;
    }
    this.store
      .select(this.menuAction.pending)
      .pipe(takeUntil(this.ngDestroyed$))
      .subscribe((pending) => (this.pending = pending));
  }

  ngOnDestroy(): void {
    this.ngDestroyed$.next();
    this.ngDestroyed$.complete();
  }

  @HostListener("click", ["$event"])
  @HostListener("keydown.space", ["$event"])
  trigger(event: Event): void {
    event.preventDefault();
    if (this.menuAction && !this.pending) {
      this.store.dispatch(this.menuAction.trigger);
    }
  }
}
